/**
 * Shared CSV helpers — escaping, blob download, and CSV file generation.
 */

const CSV_FORMULA_PREFIX_CHARS = /^[=+\-@\t\r]/

export function escapeCSV(value: string): string {
  if (CSV_FORMULA_PREFIX_CHARS.test(value)) {
    return `"'${value.replace(/"/g, '""')}"`
  }
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function downloadCSV(rows: string[][], filename: string) {
  const csvContent = rows.map((row) => row.map(escapeCSV).join(',')).join('\n') + '\n'
  downloadBlob(new Blob([csvContent], { type: 'text/csv;charset=utf-8;' }), filename)
}
